import { chartPointToPixel } from "../coordinateUtils";
import { createDrawingObject, replaceLastPoint } from "../shared";
export function calculateTrendAngleGeometry(drawing, scales) {
    const [p0, p1] = drawing.points;
    if (!p0 || !p1)
        return null;
    const start = chartPointToPixel(p0, scales);
    const end = chartPointToPixel(p1, scales);
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const angleRadians = Math.atan2(-dy, dx); // Negative dy because canvas Y is inverted
    const angleDegrees = (angleRadians * 180) / Math.PI;
    const priceChange = p1.y - p0.y;
    const priceChangePercent = p0.y !== 0 ? ((p1.y - p0.y) / p0.y) * 100 : 0;
    const barsCount = Math.abs((p1.xIndexFloat ?? 0) - (p0.xIndexFloat ?? 0)) || 0;
    return {
        start,
        end,
        angleDegrees,
        priceChange,
        priceChangePercent,
        barsCount,
    };
}
const TrendAngle = {
    name: "trendAngle",
    createDraft: (startPoint) => createDrawingObject("trendAngle", [startPoint, startPoint]),
    updateDraft: (draft, nextPoint) => replaceLastPoint(draft, nextPoint),
    render: () => undefined,
};
export default TrendAngle;
